export const DONATION_ACCOUNT = {
  bank: "Zenith Bank",
  accountNumber: "1313045685",
  accountName: "Redempta Development Foundation",
} as const
